import { Layout } from 'antd';
import styled from 'styled-components';
import background from '../../static/images/Auth-Layout-Background.jpg';

const ResetPasswordLayout = styled(Layout)`
  &&& {
    min-height: 100%;
    width: 100%;
    background: url(${background}) no-repeat center center;
    background-size: auto 50%;
    background-attachment: fixed;
    background-size: cover;
    position: absolute;
    overflow-y: auto;
    display: flex;
  }
`;

const Footer = styled(Layout.Footer)`
  &&& {
    background-color: transparent !important;
    font-size: 12px;
    color: #000000;
    text-align: center;
  }
`;

const Header = styled(Layout.Header)`
  &&& {
    background-color: transparent !important;
  }
`;

ResetPasswordLayout.Header = Header;
ResetPasswordLayout.Content = Layout.Content;
ResetPasswordLayout.Footer = Footer;

export default ResetPasswordLayout;
